import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { Typography, Grid, Button, Divider, Collapse } from '@material-ui/core';

// UTILITY
import { updateUrl } from '@/utility/common';
import { getExternalUrlParams } from '@/utility/analytics';

// COMPONENTS
import ReactHtml from '@/components/ReactHtml';

// STYLES
import { CardStyled, PriceSection, AboutWrapper, DividerContainer, CollapseTitle } from './styles';

const StaticPlanCard = props => {
  const { data, unique_id, isActive, handleVisitSite, partner } = props;
  const [t] = useTranslation();
  const [showDetails, setShowDetails] = useState(false);
  const externalUrlParams = getExternalUrlParams({ unique_id });
  const isWowPartner = partner === 'wow';

  const handleDetailsOpen = () => {
    setShowDetails(!showDetails);
  };

  return (
    <CardStyled className={clsx('package-card', isActive && 'package-card--active')}>
      {isWowPartner && isActive && (
        <Typography className="label" variant="h6" align="center">
          {t('common.recommendedPackage')}
        </Typography>
      )}
      <Typography className="title" variant="h3">
        {data.name}
      </Typography>
      <PriceSection>
        {+data.price === 0 ? (
          <span className="price">{t('common.free')}</span>
        ) : (
          <>
            <span className="price">${data.price}</span>
            <span className="period">/{t('common.month')}</span>
          </>
        )}
      </PriceSection>
      <DividerContainer>
        <Divider />
      </DividerContainer>
      <AboutWrapper>
        <ReactHtml className="markdown">{data.description?.trim()}</ReactHtml>
      </AboutWrapper>
      {!!data.details && (
        <div className="package-card__details details m-b-30">
          <CollapseTitle
            className={`details__title noselect ${showDetails ? 'details__title--open' : ''}`}
            onClick={handleDetailsOpen}
          >
            <i className="icon-chevron-right" />
            <Typography variant="h5" component="h5" align="left">
              {t('common.planDetails')}
            </Typography>
          </CollapseTitle>
          <Collapse in={showDetails}>
            <ReactHtml className="markdown">{data.details?.trim()}</ReactHtml>
          </Collapse>
        </div>
      )}
      {!!data.button_url && (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Button
              component="a"
              href={updateUrl(data.button_url, externalUrlParams)}
              onClick={handleVisitSite}
              target="_blank"
              color="primary"
              size="medium"
              fullWidth
            >
              {data.button_text || t('buttons.visitSite')}
            </Button>
          </Grid>
        </Grid>
      )}
    </CardStyled>
  );
};

StaticPlanCard.defaultProps = {
  data: {},
  unique_id: '',
  isActive: false,
  handleVisitSite: () => {},
};

StaticPlanCard.propTypes = {
  data: PropTypes.object,
  unique_id: PropTypes.string,
  isActive: PropTypes.bool,
  handleVisitSite: PropTypes.func,
  partner: PropTypes.string,
};

export default React.memo(StaticPlanCard);
